import { useEffect, useState } from 'react'
import { isPlus } from '../lib/user'
import { practiceDay } from '../lib/practice'
import { Play } from './Play'
import type { DayResult } from '../lib/types'
import { emojiForResult, formatBig, timesOff } from '../lib/scoring'
import { TopBar } from './TopBar'
import { BottomNav } from './BottomNav'

export function Practice({ onZoom }: { onZoom: (z: number) => void }) {
  const [day, setDay] = useState(() => practiceDay())
  const [result, setResult] = useState<DayResult | null>(null)
  const allowed = isPlus()
  useEffect(() => { if (!allowed) location.hash = '#/plus' }, [allowed])
  if (!allowed) return null
  if (result) {
    return (
      <div className="screen results">
        <TopBar />
        <h1>Practice over.</h1>
        <p className="sub">🎲 Practice mix — doesn't touch your streaks</p>
        <div className="emoji-string">{result.emoji}</div>
        <div className="card"><h3>Score</h3><div className="score">{result.score.toLocaleString('en-US')}<small>/5,000</small></div></div>
        <div className="actions">
          <button className="btn block" onClick={() => { setResult(null); setDay(practiceDay()) }}>Another 5 🎲</button>
          <a className="btn ghost block" href="#/">Back to today</a>
        </div>
        <ul className="qlist">
          {day.questions.map((q, k) => { const r = result.results[k]; return (
            <li key={q.id}><span className="em">{emojiForResult(r)}</span><span><div>{q.prompt}</div><div className="p">you: {formatBig(r.guess)} · within {timesOff(r.ratio)}</div></span><span className="a">{formatBig(q.answer)}<small>{q.unit}</small></span></li>
          ) })}
        </ul>
        <BottomNav />
      </div>
    )
  }
  return <Play key={day.generatedAt} day={day} replay practice onZoom={onZoom} onDone={setResult} />
}
